export default "__VITE_ASSET__kwj1OZgN__"